package com.jingfangpai.file.model

import com.jingfangpai.common.data.response.ApiResponse

data class CkEditorFileUploadError(val message:String)

data class CkEditorFileUploadResponse(var url:String?=null, var error:CkEditorFileUploadError?=null)